<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">制造单号</label>
            <span class="weui-form-preview__value">{{initData.ma_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工作中心</label>
            <span class="weui-form-preview__value">{{initData.ma_wcname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">开工日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.ma_planbegindate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工单数量</label>
            <span class="weui-form-preview__value">{{initData.ma_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">完工数量</label>
            <span class="weui-form-preview__value">{{initData.ma_madeqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">完工率%</label>
            <span class="weui-form-preview__value">{{initData.ma_maderate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">直通率%</label>
            <span class="weui-form-preview__value">{{initData.ma_ztrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">损耗金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.ma_losstotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">损耗率%</label>
            <span class="weui-form-preview__value">{{initData.ma_lossrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">完工日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.ma_actenddate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">结案日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.ma_enddate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>